/** Name particles omitted when choosing initials. */
const NAME_PARTICLES = new Set(['BIN', 'BINTI', 'BT', 'BTE', 'B', 'B.', 'A/L', 'A/P', 'AL', 'AP', 'ANAK', 'S/O', 'D/O']);

/**
 * First letter of the first two name words, after dropping particles and any "@" alias.
 * "AHMAD BIN ALI" -> "AA", "SITI NURHALIZA BINTI TARUDIN" -> "SN", "LIM MEI LING" -> "LM",
 * "MUTHU A/L RAMAN @ RAMASAMY" -> "MR", "RICHARD" -> "R". No letters at all gives "".
 */
export function initialsOf(name: string | null | undefined): string {
    const uppercaseName = (name ?? '').toUpperCase();
    // Prefer the name before an alias; use the full value if that part is empty.
    const primaryName = uppercaseName.split('@')[0].trim() || uppercaseName;
    const nameWords = primaryName
        .split(/\s+/)
        .filter((word) => /\p{L}/u.test(word) && !NAME_PARTICLES.has(word));

    // Unicode mode keeps supplementary characters (such as rare CJK letters) intact.
    return nameWords
        .slice(0, 2)
        .map((word) => word.match(/\p{L}/u)?.[0] ?? '')
        .join('');
}
